import { render, staticRenderFns } from "./sportsbookBet.vue?vue&type=template&id=00cbae83"
import script from "./sportsbookBet.vue?vue&type=script&lang=js"
export * from "./sportsbookBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports